const props = {
  hovering: Boolean,
  focusing: Boolean
};
export {
  props
};
